import Text from '@ingka/text';
import List from '@ingka/list';
import { useTranslation, Trans } from 'react-i18next';
import styles from './UserGuide.module.scss';

/* eslint-disable-next-line */
export interface UserGuideProps {}

// eslint-disable-next-line i18next/no-literal-string
const lottaEmail = 'ce.lotta.se@ingka.com';

export const UserGuide: React.FC<UserGuideProps> = () => {
  const { t } = useTranslation();

  return (
    <div className={styles['container']}>
      <Text headingSize="xl" tagName="h1" className={styles['header']}>
        {t('user-guide-header')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-intro-metatext-1')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-intro-metatext-2')}
      </Text>
      <Text headingSize="m" tagName="h1" className={styles['subheader']}>
        {t('user-guide-subheader-getting-started')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-subheader-getting-started-metatext')}
      </Text>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-navbar')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-navbar-metatext')}
      </Text>
      <List className={styles['ul-list']}>
        <li>
          <Trans
            i18nKey="user-guide-sub-subheader-navbar-overview"
            components={{ italic: <i /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="user-guide-sub-subheader-navbar-user-guide"
            components={{ italic: <i /> }}
          />
        </li>
        <li>
          <Trans
            i18nKey="user-guide-sub-subheader-navbar-your-account-modal"
            components={{ italic: <i /> }}
          />
        </li>
      </List>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-overview')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-overview-1')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-overview-p2')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-overview-p3')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-overview-p4')}
      </Text>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-create-new')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-create-new-metatext')}
      </Text>
      <List ordered>
        <li>{t('user-guide-sub-subheader-create-new-l1')}</li>
        <li>{t('user-guide-sub-subheader-create-new-l2')}</li>
        <li>{t('user-guide-sub-subheader-create-new-3')}</li>
        <li>{t('user-guide-sub-subheader-create-new-l4')}</li>
        <li>{t('user-guide-sub-subheader-create-new-l5')}</li>
      </List>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-create-new-disclaimer')}
      </Text>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-lottery-details')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-p1')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-p2')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-pnew')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-p3')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-p4')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-lottery-details-p5n')}
      </Text>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-draw-details')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-draw-details-p')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-draw-details-p1')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-draw-details-p2')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-draw-details-p3')}
      </Text>
      <Text headingSize="s" tagName="h1" className={styles['subheader']}>
        {t('user-guide-sub-subheader-further-question')}
      </Text>
      <Text tagName="p" className={styles['paragraph']}>
        {t('user-guide-sub-subheader-further-question-p1', { lottaEmail: lottaEmail })}
      </Text>
    </div>
  );
};
